<template>
  <div
    class="relative mobile:block mobile:text-center tablet:flex items-center justify-between shadow-[0px_0px_10px_-3px_#00000057] rounded-lg z-10 px-3 py-2 mt-4 bg-white">
    <p class="text-[14px] select-none tablet:mb-0 mobile:mb-2 text-[#999999]">
      Copyright © {{ currentYear }} fyxify Home Services LLC.
    </p>
    <ul class="list-inline mb-0 flex items-center mobile:justify-center">
      <!-- Figma 5689-6372 footer links + the header's How fyxify works / Contact Us (moved here, user 20 Oct) -->
      <li class="px-3 border-r border-gray-300">
        <a href="https://fyxify.pro/solutions-contractors/" target="_blank" rel="noopener noreferrer"
          class="select-none text-[14px] no-underline text-[#A084E8]">Useful Tips</a>
      </li>
      <li class="px-3 border-r border-gray-300">
        <a href="https://fyxify.pro/about-us/" target="_blank" rel="noopener noreferrer"
          class="select-none text-[14px] no-underline text-[#A084E8]">How fyxify works</a>
      </li>
      <li class="pl-3">
        <a href="https://fyxify.pro/index.html#ContactUs" target="_blank" rel="noopener noreferrer"
          class="select-none text-[14px] no-underline text-[#A084E8]">Contact Us</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  }
  // name: "FooterPartial",
};
</script>